import SeparatorSvgIcon from '@img/icons/chevron-right.svg';
import HomeSvgIcon from '@img/icons/home.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Breadcrumbs.styles';
const Breadcrumbs = (props) => {
    return (React.createElement(S.Container, { "aria-label": "breadcrumb", "data-bottom-spacing": props.bottomSpacing === false ? false : true },
        React.createElement(S.Inner, { "data-layout": props.layout ?? 'wide' },
            React.createElement(S.List, null,
                React.createElement(S.Item, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.ItemLink, { href: "/", "aria-label": "Home" },
                            React.createElement(HomeSvgIcon, null)))),
                props.items.map((item, i) => (React.createElement(React.Fragment, { key: item.id },
                    React.createElement(S.Item, null,
                        React.createElement(SeparatorSvgIcon, null)),
                    React.createElement(S.Item, { "data-first-link": i === 0 },
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.ItemLink, { href: item.url, title: item.text, "aria-current": i === props.items.length - 1 ? 'location' : undefined }, item.text))))))))));
};
export default Breadcrumbs;
